<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-map-marker-path"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('linehaul_routes') }}
        </div>
      </template>
      <v-row
        class="mx-0"
        no-gutters
      >
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-col style="text-align: right">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
            @blur="getDataFromApi"
            @keydown.enter="getDataFromApi"
          />
          <v-btn
            class="mt-5"
            color="primary"
            :to="{name: 'linehaul_routes_map'}"
          >
            Se Kort
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-icon
            medium
            color="green"
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            medium
            color="red"
            class="mr-5"
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            bottom
            right
            class="ml-auto"

            @click="editItem({id:null})"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { SUPERUSER } from '../../../utils/constants'

  export default {
    mixins: [List],

    data () {
      return {
        endpoint: 'linehaul-routes',
        name: 'linehaul_route',
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPERUSER.val,
        },
        headers: [
          {
            text: this.$t('name'),
            value: 'title',
          },
          { text: this.$t('actions'), value: 'action', align: 'right', sortable: false },

        ],
      }
    },
    methods: {
      editItem: function ({ id }) {
        this.$router.push(`/transit/linehaul/routes/${id}`)
      },
    },
  }
</script>
